import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { AppShell } from '@/components/layout/AppShell';
import { Toaster } from 'sonner';
import Landing from '@/pages/Landing';
import Marketplace from '@/pages/Marketplace';
import AgentDetail from '@/pages/AgentDetail';
import Builder from '@/pages/Builder';
import Chat from '@/pages/Chat';
import Dashboard from '@/pages/Dashboard';
import Pricing from '@/pages/Pricing';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import BillingSuccess from '@/pages/BillingSuccess';
import Share from '@/pages/Share';
import Docs from '@/pages/Docs';
import UseCases from '@/pages/UseCases';
import Admin from '@/pages/Admin';
import { RouteProtected } from '@/components/RouteProtected';

function Router() {
  const location = useLocation();
  // If returning from Emergent OAuth with #session_id, handle it before normal routes
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Landing />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/agents/:id" element={<AgentDetail />} />
        <Route path="/builder" element={<RouteProtected><Builder /></RouteProtected>} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<RouteProtected><Dashboard /></RouteProtected>} />
        <Route path="/billing/success" element={<RouteProtected><BillingSuccess /></RouteProtected>} />
        <Route path="/share/:id" element={<Share />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Landing />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: 'hsl(225 18% 8%)', border: '1px solid hsl(225 14% 18%)', color: '#F2F6FF' } }} />
          <Router />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
